import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Megaphone, Sparkles, AlertTriangle, Info } from "lucide-react";

const CAT_STYLES = {
  Info: { bg: "bg-blue-50", border: "border-blue-200", text: "text-blue-800", icon: Info, iconColor: "text-blue-500" },
  Offer: { bg: "bg-[#E6F7F5]", border: "border-[#14B8A6]/30", text: "text-[#0F8A7D]", icon: Sparkles, iconColor: "text-[#14B8A6]" },
  Warning: { bg: "bg-amber-50", border: "border-amber-200", text: "text-amber-800", icon: AlertTriangle, iconColor: "text-amber-500" },
};

const RecentNews = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get("/news");
        setItems(res.data);
      } catch { /* ignore */ } finally { setLoading(false); }
    })();
  }, []);

  if (loading || items.length === 0) return null; // hide section if no active news

  return (
    <div className="bg-white rounded-lg border border-slate-200 p-5 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Megaphone size={18} className="text-[#14B8A6]" />
        <h3 className="font-semibold text-slate-800">Recent News</h3>
        <span className="text-xs bg-slate-100 text-slate-600 px-2 py-0.5 rounded-full">{items.length}</span>
      </div>
      <div className="space-y-3">
        {items.slice(0, 5).map((n) => {
          const style = CAT_STYLES[n.category] || CAT_STYLES.Info;
          const Icon = style.icon;
          return (
            <div key={n.id} className={`${style.bg} ${style.border} border rounded-md p-3 flex items-start gap-3`}>
              <Icon size={16} className={`${style.iconColor} mt-0.5 flex-shrink-0`} />
              <div className="min-w-0 flex-1">
                <div className={`text-sm font-semibold ${style.text}`}>{n.title}</div>
                <div className="text-sm text-slate-700 mt-0.5 whitespace-pre-line">{n.body}</div>
                <div className="text-[10px] text-slate-400 mt-1">
                  {new Date(n.created_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RecentNews;
